import { useEffect, useState } from "react";

/**
 * Tracks whether the sticky "companion" below the Load Finder header (the selected-filter echo or
 * the strategy pill row) should be shown. It becomes visible once the loads table toggle scrolls
 * up to its sticky position. Returns the boolean the right pane uses to pin that companion.
 */
export const useStickyCompanion = ({
  scrollContainerRef,
  tableToggleRef,
  selectedTruck,
  selectedFilter,
  mergedTruckPrefill,
  filtersCount,
  isFiltersExpanded,
  stickyHeaderOffset,
}) => {
  const [showStickyHeader, setShowStickyHeader] = useState(false);

  useEffect(() => {
    const hasCompanion = !!selectedFilter || !!mergedTruckPrefill;
    if (!selectedTruck || !hasCompanion || !scrollContainerRef?.current) {
      setShowStickyHeader(false);
      return;
    }

    const scrollContainer = scrollContainerRef.current;

    const handleScroll = () => {
      const tableToggle = tableToggleRef.current;
      if (!tableToggle) return;

      // Position of the table toggle relative to the scroll container.
      const containerRect = scrollContainer.getBoundingClientRect();
      const toggleRect = tableToggle.getBoundingClientRect();
      const toggleTopRelativeToContainer = toggleRect.top - containerRect.top;

      // Show the sticky companion (filter echo or strategy pill row) once the table toggle
      // reaches its sticky position.
      setShowStickyHeader(toggleTopRelativeToContainer <= stickyHeaderOffset);
    };

    scrollContainer.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // Check initial state

    return () => scrollContainer.removeEventListener("scroll", handleScroll);
  }, [
    selectedTruck,
    filtersCount,
    selectedFilter,
    mergedTruckPrefill,
    stickyHeaderOffset,
    isFiltersExpanded,
    scrollContainerRef,
    tableToggleRef,
  ]);

  return showStickyHeader;
};
